import styled from "styled-components/macro";
export const TableContainer = styled.div``;

export const SectionContainer = styled.div`
  max-width: 50rem;
`;
